import { Link } from 'react-router-dom';
import { useDeletePrompt } from '../../hooks/usePrompts';
import { Prompt } from '../../types';
import DeleteResourceControl from '../shared/DeleteResourceControl';

interface PromptCardProps {
  prompt: Prompt;
}

export default function PromptCard({ prompt }: PromptCardProps) {
  const deletePrompt = useDeletePrompt();

  return (
    <div className="group relative bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow duration-200">
      <Link to={`/prompts/${prompt.id}`} className="block">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white group-hover:text-indigo-600 dark:group-hover:text-indigo-400">
              {prompt.name}
            </h3>
            {prompt.content && (
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 line-clamp-3">
                {prompt.content}
              </p>
            )}
            {prompt.isActive === 'true' && (
              <div className="mt-2">
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200">
                  Active
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Created {new Date(prompt.createdAt).toLocaleDateString()}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Updated {new Date(prompt.updatedAt).toLocaleDateString()}
          </div>
        </div>
      </Link>

      {/* One delete affordance for the whole app (task 864): the flag, the
          dialog, the dependents preview, the mutation and the toast in one
          place. The inline two-step swap this replaces said nothing about
          what else used the resource, and offered no way back. */}
      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
        <DeleteResourceControl
          flag="innovate.fe.prompts.delete"
          entity="prompts"
          entityLabel="prompt"
          name={prompt.name}
          id={prompt.id}
          stopPropagation
          body={<p>Agents using it stop using it; nothing else about them changes.</p>}
          onDelete={() => deletePrompt.mutateAsync(prompt.id)}
        />
      </div>
    </div>
  );
}
